import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./styles/CTASection.css";

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="cta-clean">
      <motion.div
        className="cta-clean__container"
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.35 }}
        transition={{ duration: 0.65 }}
      >
        <div className="cta-clean__left">
          <div className="cta-clean__eyebrow">Start the conversation</div>
          <h2 className="cta-clean__title">
            Let&apos;s build the right solution
            <span> for your business.</span>
          </h2>
          <p className="cta-clean__text">
            Whether you need support, infrastructure planning, cloud guidance,
            or a strategic technology partner, our team is ready to help you
            move forward with clarity.
          </p>
        </div>

        <div className="cta-clean__right">
          <div className="cta-clean__card">
            <div className="cta-clean__label">Direct engagement</div>

            <button
              className="cta-clean__button"
              onClick={() => navigate("/contact")}
            >
              Engage With an Expert
            </button>

            <p className="cta-clean__note">
              Share your goals, timeline, or current challenges and we’ll help
              point you in the right direction.
            </p>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default CTASection;
